module.exports = __webpack_public_path__ + "static/media/oldmen_walking.2ae304c9.png";